/*** IMPORTS FROM imports-loader ***/
var define = false;

'use strict';

module.exports = require('./lib/React');




//////////////////
// WEBPACK FOOTER
// ./~/.npminstall/react/15.4.2/react/react.js
// module id = 6
// module chunks = 0